<template>
  <section>
    <v-parallax :src="'/images/front/' + randomImage.src" :height="getSectionHeight(windowWidth)">
      <v-row align-content="center" class="position-relative">
        <v-row class="text-center mt-0 mt-sm-15 mb-5 mb-sm-12 full-width">
          <v-col class="pa-1">
            <h1 class="text-xs-center pretopia-head-font pretopia-display-2 font-weight-regular black-text-shadow">
              {{ $t('home.hero.title') }}
            </h1>
          </v-col>
        </v-row>

        <v-row class="white--text2 position-relative">
          <v-col md="12" lg="10" xl="8" offset-lg="1" offset-xl="2" class="text-center">
            <seach-filter></seach-filter>
          </v-col>
        </v-row>
        <v-btn v-if="searchStore.isSearching" class="search-spinner-button" outlined fab dark :loading="true">
          <v-icon>mdi-format-list-bulleted-square</v-icon>
        </v-btn>
      </v-row>

      <div class="bgimage-copyright">
        {{ $t('home.hero.imageBelongsTo') }}
        <a :href="randomImage.companyUrl" class="white--text" target="_blank">{{ randomImage.company }}</a>
      </div>
    </v-parallax>
  </section>
</template>

<script>
import { mapStores } from 'pinia';
import { useSearchStore } from '../../../stores/SearchStore';
import SeachFilter from './SeachFilter.vue';

export default {
  components: { SeachFilter },

  data() {
    return {
      isSearching: false,
      windowWidth: document.documentElement.clientWidth,
      subscriptions: []
    }
  },

  mounted() {
    window.addEventListener('resize', this.updateWindowWidth);
  },

  destroyed() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },

  computed: {
    ...mapStores(useSearchStore),

    randomImage() {
      const min = 0;
      const max = 5;
      const number = Math.floor(Math.random() * (max - min) + min);
      return [
        {
          src: 'Scandinavisk_Spismiljö_front.jpg',
          company: 'Scandinavisk Spismiljö',
          companyUrl: 'https://spismiljo.se',
        },
        {
          src: 'muurikka_front.jpg',
          company: 'Muurikka',
          companyUrl: 'https://muurikka.se',
        },
        {
          src: 'inr_front.jpg',
          company: 'INR',
          companyUrl: 'https://www.inr.se',
        },
        {
          src: 'gabriel_keramik_front.jpg',
          company: 'Gabriel Keramik',
          companyUrl: 'https://www.gabrielkakelugnar.se',
        },
        {
          src: 'eldstickan_front.jpg',
          company: 'Eldstickan',
          companyUrl: 'https://eldstickan.com',
        },
      ][number];
    },
  },

  methods: {
    updateWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
    },

    getSectionHeight(windowWidth) {
      if (windowWidth < 600) return 800 
      if (windowWidth <= 960) return 580;
      return 510
    }
  }
};
</script>

<style lang="scss">

.bgimage-copyright {
  position: absolute;
  bottom: 10px;
  color: #ccc;
  font-style: italic;

  a,
  a:hover {
    color: #ccc;
    text-decoration: none;
  }
}

@media (max-width: 600px) {
  .bgimage-copyright {
    bottom: 70px;
  }
}

.search-spinner-button {
  position: absolute;
  bottom: 17px;
  left: 46%;
  // margin: 73px 47% 0 47% !important;
}

@media (min-width: 960px) {
  .search-spinner-button {
    bottom: 18px;
    left: 48%;
  }
}

@media (min-width: 1264px) {
  .search-spinner-button {
    bottom: 18px;
    left: 48%;
  }
}


</style>